import ImageGallery from 'react-image-gallery';

const images = [
  {
    original: '/picture/gallery/event_1.jpg',
    originalHeight: '500px'
  },
  {
    original: '/picture/gallery/event_2.jpg',
    originalHeight: '500px'
  },
  {
    original: '/picture/gallery/event_3.jpg',
    originalHeight: '500px'
  },
  {
    original: '/picture/gallery/event_4.jpg',
    originalHeight: '500px'
  },
  {
    original: '/picture/gallery/event_5.jpg',
    originalHeight: '500px'
  },
  {
    original: '/picture/gallery/event_6.jpg',
    originalHeight: '500px'
  }
];

export default function EventSection() {
  return (
    <section id="Imprezy">
      <div id="imprezy"></div>
      <div className="section events">
        <div className='sectionCol'>
          <div>
            <h1 class="tac">Imprezy zamkniete</h1>
            <p style={{marginBottom: "10px"}}><b>Zorganizuj z nami swoją imprezę urodzinową, firmową, okolicznościową!</b></p>

            <p>Imprezy wyceniane są indywidualnie, a finalna cena zależy od Państwa potrzeb i zakresu wybranych usług. Nasza oferta obejmuje:</p>

            <ul style={{ marginLeft: "20px" }}>
              <li>Barmanów (lub opcję wniesienia własnego alkoholu)</li>
              <li>Catering</li>
              <li>DJa który poprowadzi imprezę, także z opcją karaoke. Istnieje także opcja podłączenia własnej muzyki</li>
              <li>Kelnerki i kelnerów</li>
              <li>Ochronę</li>
              <li>Inne wedle Państwa potrzeb</li>
              <li>Sprawy podstawowe takie jak: osoba nadzorująca oraz sprzątanie</li>
            </ul>

            <p style={{marginTop: "15px"}}>Zachęcamy do wypełnienia formularza na naszej stronie! Chętnie i najszybciej jak to możliwe odpowiemy na wszystkie pytania!</p>
          </div>
          <h3 style={{ marginBottom: "10px", marginTop: "20px" }}>Skontaktuj się z nami:</h3>
          <ul style={{ marginLeft: "20px" }}>
            <li>Wypełnij <a class="eventLinks" href="#EventForm"><b><u>formularz rezerwacji</u></b></a>, a na pewno się odezwiemy i dogadamy :)</li>
            <li>Napisz do nas maila pod adres <a class="eventLinks" href="mailto:singersrezerwacje@gmail.com"><b><u>singersrezerwacje@gmail.com</u></b></a> i opisz czego od nas oczekujesz, a my odpiszemy jak najszybciej to możliwe!</li>
            <li>Zadzwoń bezpośrednio do restauracji pod numer <a class="eventLinks" href="tel:535478687"><b><u>535 478 687</u></b></a></li>
          </ul>
        </div>
        <div className="sectionCol" style={{ alignItems: 'center' }}>
          <ImageGallery items={images} showNav={false} showBullets={true} autoPlay={true} slideDuration={500} />
        </div>
      </div>
    </section>
  )
}